
import { mapActions, mapState, mapGetters } from "vuex";
import OrderAlertCancelledOrder from "./order-alert-cancelled-order.vue";
import OrderAlertNewOrder from "./order-alert-new-order.vue";

export default {
  components: {
    OrderAlertNewOrder,
    OrderAlertCancelledOrder
  },
  data() {
    return {
      showToast: false
    };
  },
  watch: {
    cancelledOrders() {
      this.resetShowToast();
    },
    showNewOrderAlert() {
      this.resetShowToast();
      if (this.hasNewOrders) {
        this.$nuxt.$emit(
          "trigger-push-notification",
          "New Order",
          "Source: " +
            this.getChannelConstObj(this.getAllChannelNewOrders[0].source)
              .label,
          this.getAllChannelNewOrders[0]
        );
      }
    }
  },
  computed: {
    ...mapState("reciever", ["orders", "cancelledOrders"]),

    ...mapGetters("reciever", ["getAllChannelNewOrders"]),
    hasNewOrders() {
      return (
        this.getAllChannelNewOrders && this.getAllChannelNewOrders.length > 0
      );
    },
    showNewOrderAlert() {
      return this.$vuetify.breakpoint.mdAndUp
        ? this.$route.name !== "reciever" && this.hasNewOrders
        : this.hasNewOrders;
    }
  },

  methods: {
    resetShowToast() {
      this.showToast =
        this.showNewOrderAlert ||
        (this.cancelledOrders && this.cancelledOrders.length > 0);
    }
  }
};
